import { AssetAggregateDto, Country, ReferenceApi } from 'services/generated';
import { rootApi } from 'store/root-api';
import api from 'services/api';
import { handleErrors } from 'services/helpers';

const referencesClient = new ReferenceApi(undefined, undefined, api);

const referencesApi = rootApi.injectEndpoints({
  endpoints: builder => ({
    getCountries: builder.query<Country[], void>({
      queryFn: () => handleErrors(() => referencesClient.listCountries()),
      providesTags: [{ type: 'Countries', id: 'LIST' }],
    }),
    getAssets: builder.query<AssetAggregateDto[], void>({
      queryFn: () => handleErrors(() => referencesClient.listAssets()),
      providesTags: [{ type: 'Assets', id: 'LIST' }],
    }),
  }),
});

export const { useGetCountriesQuery, useGetAssetsQuery } = referencesApi;
